import { useContext } from 'preact/hooks'
import { BlockTreeContextValue, BlockTreeContext } from './BlockTreeContext'

export const useBlockTreeMapping = (): BlockTreeContextValue | null => useContext(BlockTreeContext)
